import { type AreaData, HistogramSeries, type ICustomSeriesPaneView, LineSeries, type SeriesDefinition, type SeriesType, type Time } from "lightweight-charts"
import { StackedAreaSeries } from "../../options/historical-charts/stacked-area-series-plugin/stacked-area-series"
import { type ChartColor } from "./colors.values"

export interface SeriesOptions {
  color?: ChartColor
}

export class Series {
  constructor(
    public name: string,
    public points: Array<AreaData<Time>>,
    public options: SeriesOptions
  ) { }

  get max() { return Math.max(...this.points.map(p => p.value)) }
}

export enum SeriesTypeEnum {
  StackedArea = "Stacked Area",
  Line = "Line",
  Histogram = "Histogram"
}

// @ts-ignore
export const seriesDefinitionsMap = new Map<SeriesTypeEnum, SeriesDefinition<SeriesType> | ICustomSeriesPaneView<any, any>>([
  [SeriesTypeEnum.StackedArea, StackedAreaSeries],
  [SeriesTypeEnum.Line, LineSeries],
  [SeriesTypeEnum.Histogram, Object.assign({}, HistogramSeries, {  priceLineVisible: false,
  lastValueVisible: false, })],
])

// TODO inner prop ?
export const isCustomSeries = (value: any): boolean => !(value && value.isBuiltIn)  
